<template>
  <div id="print">

    <div class="book m-auto">

      <div
        v-for="(data, idx) in Math.ceil(stocks.length/maxItems)"
        :key="idx"
        class="page"
      >
        <div class="subpage">

          <div
            class="top-header"
            style="border: none;">
            <div
              v-if="idx == 0"
              class="company-info">
              <img
                v-if="shopInfo.logo.thumbnail"
                :src="shopInfo.logo.thumbnail">
              <div class="name">
                <strong class="text-black">{{ shopInfo.shop_name }}</strong>
                <p>{{ shopInfo.info.location.address }}</p>
              </div>
            </div>
            <div class="document-type">
              <h2 class="text-black">{{ warehouse.name }}</h2>
              <p>{{ time }}</p>
            </div>
          </div>

          <div
            class="order"
            style="margin-top: 20px;">
            <table>
              <thead>
                <tr>
                  <td width="10px"><b>#</b></td>
                  <td width="40%"><b>{{ $t('message.item') }}</b></td>
                  <td class="text-right"><b>{{ $t('apps.inventory.message.warningstock') }}</b></td>
                  <td class="text-right"><b>{{ $t('apps.inventory.message.binlocation') }}</b></td>
                  <td class="text-right"><b>{{ $t('apps.inventory.message.balance') }}</b></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx_) in groupItems[idx].items"
                  :key="idx_"
                >
                  <td width="10px">{{ (maxItems*idx)+(idx_+1) }}</td>
                  <td width="40%">{{ getProductFullName(item.product.product_name, item.sku.attributes) }}</td>
                  <td class="text-right">{{ getNumber(item.stock.control.minstock) }}</td>
                  <td class="text-right">
                    {{ getBinLocationNamesByStock(item).join(', ') }}
                  </td>
                  <td class="text-right">{{ getNumber(item.stock.instock) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    stocks: {
      type: Array,
    },
    warehouse: {
      type: Object,
    },
    time: {
      type: String,
    },
  },
  data () {
    return {
      maxItems: 25,
      query: {
        wh_id: this.$route.query.wh_id,
      },
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      warehouses: 'getWarehouses',
    }),
    groupItems () {
      var results = []
      var currentIdx = 0

      for (let i = 0; i < Math.ceil(this.stocks.length / this.maxItems); i++) {
        var page = i + 1

        results.push({
          'page': page,
          'items': [],
        })
      }

      for (let i = 0; i < this.stocks.length; i++) {
        let item = this.stocks[i]

        if (i % (this.maxItems) == 0 && i !== 0) {
          currentIdx++
        }

        results[currentIdx]['items'].push(item)
      }

      return results
    },
  },
  methods: {
    ...mapActions([

    ]),
    getBinLocationNamesByStock(stock) {
      const binIds = []

      stock.stock_locations.forEach(item => {
        if (item.bin_location_id != null && !binIds.includes(item.bin_location_id)) {
          binIds.push(item.bin_location_id)
        }
      })

      return binIds
        .map((id) => this.getBinLocationNamesById(id))
        .filter((v) => v)
    },
    getBinLocationNamesById(binId) {
      const bins = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.query.wh_id) {
          acc = cur.bin_locations
        }
        return acc
      }, [])
      const bin = bins.find((bin) => bin._id === binId)
      return bin
        ? bin.code
        : null
    },
  },
  created: async function () {

  },
  mounted: function () {

  },
}
</script>

<style scoped>
  @page {
      size: A4;
      margin: 0;
  }

  @media print {
      #print .page {
          margin: 0;
          border: initial;
          border-radius: initial;
          width: initial;
          min-height: initial;
          box-shadow: initial;
          background: initial;
          page-break-after: always;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/stockcontrol/include/PrintPreview.vue